import React from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { db, firebase } from 'firebase/fbConfig.js';

// react component for creating dynamic tables
import ReactTable from 'react-table';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import Card from 'components/Card/Card.jsx';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';

// @material-ui/icons
import Assignment from '@material-ui/icons/Assignment';
import Dvr from '@material-ui/icons/Dvr';
import Favorite from '@material-ui/icons/Favorite';
import Check from '@material-ui/icons/Check';
import Close from '@material-ui/icons/Close';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import ArrowDownward from '@material-ui/icons/ArrowDownward';

// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import ProfilePicUpload from 'components/CustomUpload/profilePicUpload';
import CardBody from 'components/Card/CardBody.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import Table from 'components/Table/Table.jsx';
import CardAvatar from 'components/Card/CardAvatar.jsx';

import { cardTitle } from 'assets/jss/material-dashboard-pro-react.jsx';
import Style from 'assets/jss/material-dashboard-pro-react/views/profileStyle';
import { Grid } from '@material-ui/core';

// Forms
import ProfileForm from 'components/Forms/ProfileForm.jsx';

// Assets
import DefaultProfile from 'assets/img/default-avatar.png';

const Transition = (props) => {
  return <Slide direction='down' {...props} />;
};

class PrivateProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataLoaded: false,
      updateProfileModal: false,
      updatePhotoModal: false,
    };
  }

  handleClickOpen = (modal) => {
    var x = [];
    x[modal] = true;
    this.setState({
      ...x,
    });
  };

  handleClose = (modal) => {
    var x = [];
    x[modal] = false;
    this.setState(x);
  };

  loadData = () => {
    this.setState({
      dataLoaded: true,
    });
  };

  render() {
    const { AuthBool, classes, user, assessments } = this.props;

    console.log(this.props);

    let profilePhoto = DefaultProfile;
    if (AuthBool) {
      // fixes freeze on logout
      if (user.dataLoaded) {
        user.avatar
          ? (profilePhoto = user.avatar)
          : // add link to profile photo to firestore
            (profilePhoto = !!this.props.authUser.photoURL
              ? this.props.authUser.photoURL
              : DefaultProfile);
        // add profile photo to firebase storage
        // update redux with link
      }
    }

    if (user.dataLoaded && assessments.dataLoaded && !this.state.dataLoaded) {
      this.loadData();
    }
    return (
      <GridContainer justify='center'>
        <GridItem xs={12} sm={12} md={12}>
          {this.state.dataLoaded ? (
            <GridContainer>
              <GridItem xs={12}>
                {this.state.dataLoaded ? (
                  this.props.assessments.assessments.map((assessment) => {
                    return <p>{assessment.question1}</p>;
                  })
                ) : (
                  <p>Loading...</p>
                )}
              </GridItem>
              {/*<GridItem xs={10} sm={8} lg={4}>
                <div onClick={() => this.handleClickOpen("updatePhotoModal")}>
                  <img
                    className={classes.profilePic}
                    src={profilePhoto}
                    alt="User Photo"
                  />
                  <p className={classes.body}>Update Photo</p>
                </div>
              </GridItem>
              <GridItem xs={12} sm={6} lg={4}>
                <h4 className={classes.subTitle}>NAME:</h4>
                {this.props.user.firstName ? <p className={classes.body}>{this.props.user.firstName} {this.props.user.lastName ? this.props.user.lastName : null}</p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>COMPANY NAME:</h4>
                {this.props.user.companyName ? <p className={classes.body}>{this.props.user.companyName}</p> : <p className={classes.body}>Click UPDATE to add company name</p>}
                <h4 className={classes.subTitle}>EMAIL:</h4>
                <p className={classes.body}>{this.props.user.email}</p>
                <h4 className={classes.subTitle}>PHONE:</h4>
                {this.props.user.phone ? <p className={classes.body}>{this.props.user.phone}</p> : <p className={classes.body}>Click UPDATE to add phone number</p>}

              </GridItem>
              <GridItem xs={12} sm={6} lg={4}>

                <h4 className={classes.subTitle}>SPECIAL MEMBER DESIGNATION:</h4>
                {
                  this.props.user.groups.length > 0 ? (
                    this.props.user.groups.map(group => {
                      return <p className={classes.body} key={group}>{group}</p>
                    })
                  ) : (
                      <p className={classes.body}>click UPDATE to add yourself to groups</p>
                    )
                }
                <h4 className={classes.subTitle}>SIGNED DOCUMENTS:</h4>
                {
                  this.props.user.termGroups.length > 0 ? (
                    this.props.user.termGroups.map(termGroup => {
                      return <p className={classes.body} key={termGroup}>{termGroup}</p>
                    })
                  ) : (
                      <p className={classes.body}>click UPDATE to sign documents</p>
                    )
                }
                <Button
                  color="primary"
                  onClick={() => this.handleClickOpen("updateProfileModal")}
                >UPDATE</Button>
              </GridItem>*/}
              <br />
              <br />
              <br />
              <GridItem xs={12} sm={12} md={12}>
                <Card profile>
                  <div onClick={() => this.handleClickOpen('updatePhotoModal')}>
                    <CardAvatar profile>
                      <img
                        className={classes.profilePic}
                        src={profilePhoto}
                        alt='User Photo'
                      />
                    </CardAvatar>
                    Update Photo
                  </div>
                  <CardBody profile>
                    {/*<h6 className={classes.cardCategory}>CEO / CO-FOUNDER</h6>*/}
                    {this.props.user.firstName ? (
                      <h4 className={classes.body}>
                        {this.props.user.firstName}{' '}
                        {this.props.user.lastName
                          ? this.props.user.lastName
                          : null}
                      </h4>
                    ) : (
                      <p className={classes.body}>
                        Click UPDATE to add your name
                      </p>
                    )}
                    <p className={classes.description}>
                      {this.props.user.barNumber ? (
                        'Bar #' + this.props.user.barNumber
                      ) : (
                        <p className={classes.body}>
                          Click UPDATE to add your Information
                        </p>
                      )}{' '}
                      |{' '}
                      {this.props.user.city
                        ? this.props.user.city
                        : 'Click UPDATE to add your City'}
                      , {this.props.user.state ? this.props.user.state : null}
                      <br />
                      Experience Level:{' '}
                      <b>
                        {this.props.user.experience
                          ? this.props.user.experience + ' years'
                          : 'Click UPDATE to add your Experience'}
                      </b>
                    </p>
                    {/*<Button color="rose" round>
                    Follow
                </Button>*/}
                  </CardBody>
                </Card>
                <Card paper='true'>
                  <CardHeader paper='true'>
                    <h4 className={classes.cardTitle}>Contact Information</h4>
                  </CardHeader>
                  <CardBody paper='true'>
                    {/*<h6 className={classes.cardCategory}>CEO / CO-FOUNDER</h6>*/}
                    <p className={classes.description}>
                      <b>
                        {this.props.user.firmName
                          ? this.props.user.firmName
                          : 'Click UPDATE to add your Name'}
                      </b>
                      <br />
                      {this.props.user.address
                        ? this.props.user.address
                        : 'Click UPDATE to add your Address'}
                      <br />
                      {this.props.user.city ? this.props.user.city : null},{' '}
                      {this.props.user.state ? this.props.user.state : null}{' '}
                      {this.props.user.zip ? this.props.user.zip : null}
                    </p>
                    <p className={classes.description}>
                      {this.props.user.phone
                        ? this.props.user.phone
                        : 'Click UPDATE to add your Phone'}
                    </p>
                    <p className={classes.description}>
                      {this.props.user.email
                        ? this.props.user.email
                        : 'Click UPDATE to add your Email'}
                    </p>

                    {/*<Button color="rose" round>
                    Follow
                </Button>*/}
                  </CardBody>
                </Card>
                <Card paper='true'>
                  <CardHeader paper='true'>
                    <h4 className={classes.cardTitle}>Profile</h4>
                  </CardHeader>
                  <CardBody paper='true'>
                    {/*<h6 className={classes.cardCategory}>CEO / CO-FOUNDER</h6>*/}
                    <p className={classes.description}>
                      {this.props.user.bio
                        ? this.props.user.bio
                        : 'Click UPDATE to add your Bio'}
                    </p>

                    {/*<Button color="rose" round>
                  Follow
              </Button>*/}
                  </CardBody>
                </Card>
                <Card paper='true'>
                  <CardHeader paper='true'>
                    <h4 className={classes.cardTitle}>Availability</h4>
                  </CardHeader>
                  <CardBody paper='true'>
                    {/*<h6 className={classes.cardCategory}>CEO / CO-FOUNDER</h6>*/}
                    <p className={classes.description}>Accepting new clients</p>
                    {/*<Button color="rose" round>
                    Follow
                </Button>*/}
                  </CardBody>
                </Card>
                <Card paper='true'>
                  <CardHeader paper='true'>
                    <h4 className={classes.cardTitle}>Fynda Memberships</h4>
                  </CardHeader>
                  <CardBody paper='true'>
                    {/*<h6 className={classes.cardCategory}>CEO / CO-FOUNDER</h6>*/}
                    {this.props.user.groups.length > 0 ? (
                      this.props.user.groups.map((group) => {
                        return (
                          <p className={classes.body} key={group}>
                            {group}
                          </p>
                        );
                      })
                    ) : (
                      <p className={classes.body}>
                        Click UPDATE to add yourself to Associations
                      </p>
                    )}

                    {/*<Button color="rose" round>
                  Follow
              </Button>*/}
                  </CardBody>
                </Card>
                <Button
                  color='primary'
                  onClick={() => this.handleClickOpen('updateProfileModal')}
                >
                  UPDATE
                </Button>
              </GridItem>

              {/* UPDATE PROFILE MODAL */}
              <Dialog
                classes={{
                  root: classes.modalRoot,
                  paper: classes.modal + ' ' + classes.modalSmall,
                }}
                open={this.state.updateProfileModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => this.handleClose('updateProfileModal')}
                aria-labelledby='shipment-modal-slide-title'
                aria-describedby='shipment-modal-slide-description'
              >
                <DialogTitle
                  id='shipment-modal-slide-title'
                  disableTypography
                  className={classes.modalHeader}
                >
                  <Button
                    simple
                    className={classes.modalCloseButton}
                    key='close'
                    aria-label='Close'
                    onClick={() => this.handleClose('updateProfileModal')}
                  >
                    {' '}
                    <Close className={classes.modalClose} />
                  </Button>
                  <h2 className={classes.modalTitle}>EDIT PROFILE</h2>
                </DialogTitle>
                <DialogContent
                  id='shipment-modal-slide-description'
                  className={classes.modalBody}
                >
                  {/* FORM */}
                  {AuthBool ? (
                    <ProfileForm
                      user={this.props.user}
                      uid={this.props.authUser.uid}
                      modalOpen={this.state.updateProfileModal}
                    />
                  ) : null}
                  <Button
                    className={classes.ltrButtonWhite}
                    style={{
                      marginLeft: '10px',
                      marginTop: '10px',
                    }}
                    key='close'
                    aria-label='Close'
                    onClick={() => this.handleClose('updateProfileModal')}
                  >
                    CLOSE
                  </Button>
                </DialogContent>
              </Dialog>

              {/* UPDATE PROFILE PHOTO MODAL */}
              <Dialog
                style={{ backgroundColor: '#FFFFFF' }}
                classes={{
                  root: classes.modalRoot,
                  paper: classes.modal + ' ' + classes.modalSmall,
                }}
                open={this.state.updatePhotoModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => this.handleClose('updatePhotoModal')}
                aria-labelledby='shipment-modal-slide-title'
                aria-describedby='shipment-modal-slide-description'
              >
                <DialogTitle
                  id='shipment-modal-slide-title'
                  disableTypography
                  className={classes.modalHeader}
                >
                  {/* <Button
                    simple
                    className={classes.modalCloseButton}
                    key="close"
                    aria-label="Close"
                    onClick={() => this.handleClose("updatePhotoModal")}
                  >
                    {" "}
                    <Close className={classes.modalClose} />
                  </Button> */}
                  {/* <h2 className={classes.modalTitle}>UPDATE PROFILE PHOTO</h2> */}
                </DialogTitle>
                <DialogContent
                  style={{
                    backgroundColor: '#FFFFFF',
                    margin: '0px 20px 0px 20px',
                    borderRadius: '10px',
                  }}
                  id='shipment-modal-slide-description'
                  className={classes.modalBody}
                >
                  {/* FORM */}
                  <ProfilePicUpload
                    currentPic={profilePhoto}
                    username={this.props.user.username}
                    uid={this.props.authUser.uid}
                  />
                  <div
                    style={{
                      textAlign: 'center',
                    }}
                  >
                    <Button
                      className={classes.ltrButtonWhite}
                      style={{ backgroundColor: '#6672e5' }}
                      key='close'
                      aria-label='Close'
                      onClick={() => this.handleClose('updatePhotoModal')}
                    >
                      CANCEL
                    </Button>
                  </div>
                </DialogContent>
              </Dialog>
            </GridContainer>
          ) : (
            <p className={classes.body}>Loading...</p>
          )}
        </GridItem>
      </GridContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    AuthBool: !!state.user,
    authUser: state.user,
    user: state.user,
    assessments: state.assessment,
  };
};

// const mapDispatchToProps = (dispatch) => {
//   return {
//     setUserScore: (score) => dispatch(setUserScore(score))
//   }
// }

export default compose(
  connect(mapStateToProps),
  withStyles(Style)
)(PrivateProfile);
